<template>
  <responsive-modal v-model="visible">
    <div class="tool-modal-telegram p-5">
      <button class="btn text-secondary close" @click="visible = false">
        <i class="icon-x" />
      </button>
      <div class="mb-5">
        <strong>
          Integração Telegram
        </strong>
      </div>
      <small>
        <div class="mb-5">
          <a
            target="_blank"
            href="https://telegram.org/"
            class="text-primary font-weight-bold text-decoration-none"
          >
            Conheça o Telegram
          </a>
        </div>

        Para configurar sua integração, siga os seguintes passos: <br />
        - Usando o botão start, inicie a conversa com o BlitzBot, nosso robô do
        Telegram. <br />
        - Adicione o nosso robô como administrador a seus grupos ou canais no
        telegram com todas as permissões ativadas.
        <br />
        - Você receberá um código que será usado para concluir esse cadastro
        <strong>
          (código de configuração do telegram)
        </strong>
        .
      </small>
      <hr />
      <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
        <form-group
          :disabled="form.id != null"
          slim
          select
          id="product-select"
          label="Nome do produto"
          v-model="form.product_id"
          :errors="errors.product_id"
          placeholder="Selecionar produto..."
          :options="products.map(({ id, name }) => ({ id, name }))"
        />
      </action-dispatcher>
      <form-group
        id="group-name"
        v-model="form.group_name"
        :errors="errors.group_name"
        label="Nome do grupo"
        placeholder="Digite o nome do grupo"
      />
      <form-group
        id="config-code"
        v-model="form.telegram_config_code"
        :errors="errors.telegram_config_code"
        label="Código de configuração do telegram"
        placeholder="Digite o código de configuração"
      />
      <form-group
        id="chat-id"
        v-model="form.chat_id"
        :errors="errors.chat_id"
        label="ID do chat (opcional)"
        placeholder="Digite o ID do chat"
      />
      <form-group
        label="Descrição da integração (Opcional)"
        id="description"
        v-model="form.description"
        :errors="errors.description"
        placeholder="Digite a descrição da integração..."
      />
      <div class="d-flex justify-content-center mt-5">
        <button
          class="btn btn-primary"
          :disabled="!isValid"
          :class="{
            'btn-secondary border-secondary': !isValid
          }"
          @click="submit"
        >
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { clearObject, formFields } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields([
        "product_id",
        "group_name",
        "description",
        "telegram_config_code",
        "chat_id",
        "status"
      ]),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
      }
    }
  },
  computed: {
    ...mapState("product", ["products"]),
    isValid() {
      return (
        this.form.product_id &&
        this.form.group_name &&
        this.form.telegram_config_code
      );
    }
  },
  methods: {
    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    onSuccess() {
      this.loading = false;
      this.$message.success("A integração foi salva!");
      this.$emit("update-list");
      this.clear();
      this.visible = false;
    },
    submit() {
      if (this.loading) return;

      this.loading = true;

      let data = {
        ...this.form
      };
      let action = "integration/postIntegration";

      if (this.integrationToEdit) {
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, clearObject(data))
        .then(this.onSuccess)
        .catch(e =>
          this.handleErrors(
            e,
            "TRANSLATE_FIELD_INTEGRATION_MAP",
            "Erro ao salvar integração"
          )
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-telegram {
  position: relative;
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }

  button {
    i {
      font-size: 28px;
    }
  }
}
</style>
